import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { ref: "rootElement" }
const _hoisted_2 = {
  key: 0,
  class: "opPaginationContainer top"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "white" }, "Clear filters", -1)
const _hoisted_4 = { class: "opItemsPerPageContainer" }
const _hoisted_5 = { class: "me-2 d-flex flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: 10 }, "10", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: 25 }, "25", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: 50 }, "50", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: 100 }, "100", -1)
const _hoisted_10 = {
  class: "mb-4",
  style: {"width":"100%","overflow-x":"auto"}
}
const _hoisted_11 = {
  class: "opTable",
  ref: "tableRoot"
}
const _hoisted_12 = {
  key: 1,
  class: "opPaginationContainer bottom"
}
const _hoisted_13 = { class: "me-2" }

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showUpperPagination)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", null, [
            (!_ctx.hideClearFilters)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-small secondaryButton",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClearFilters && _ctx.onClearFilters(...args)))
                }, [
                  _hoisted_3
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, "Items: " + _toDisplayString(_ctx.xData.length), 1),
            _withDirectives(_createVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.xItemsPerPage = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.calcPagination && _ctx.calcPagination(...args)))
            }, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9
            ], 544), [
              [_vModelSelect, _ctx.xItemsPerPage]
            ]),
            _createVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, " < "),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
              return (_openBlock(), _createBlock("div", {
                class: ["opPaginationNumber", {selected: _ctx.selectedPage == i}],
                key: i,
                onClick: ($event: any) => (_ctx.setSelectedPage(i))
              }, _toDisplayString(i), 11, ["onClick"]))
            }), 128)),
            _createVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, " > ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_10, [
      _createVNode("table", _hoisted_11, [
        _renderSlot(_ctx.$slots, "default", { data: _ctx.paginated })
      ], 512)
    ]),
    (_ctx.showLowerPagination)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode("span", _hoisted_13, "Items: " + _toDisplayString(_ctx.xData.length), 1),
          _createVNode("div", {
            class: "opPaginationNumber",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
          }, " < "),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
            return (_openBlock(), _createBlock("div", {
              class: ["opPaginationNumber", {selected: _ctx.selectedPage == i}],
              key: i,
              onClick: ($event: any) => (_ctx.setSelectedPage(i))
            }, _toDisplayString(i), 11, ["onClick"]))
          }), 128)),
          _createVNode("div", {
            class: "opPaginationNumber",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
          }, " > ")
        ]))
      : _createCommentVNode("", true)
  ], 512))
}